(function($){
    'use strict';
    (() => {
        const selectors = {
            hamburger: '#header--hamburger',
            body: "body",
            nav: '#mobile-nav',
        };

        class Navigation {
            constructor() {
                this.$hamburger = $(selectors.hamburger);
                this.$nav = $(selectors.nav);
                this.$body = $(selectors.body);

                this.init();
            }

            toggleNav = e => {
                this.$body.toggleClass("nav-showing");
                this.$nav.toggleClass('is-open');
                this.$hamburger.toggleClass('active');

                if (this.$hamburger.hasClass('active')) {
                    General.startScroll();
                } else {
                    General.stopScroll();
                }
            };

            init() {
                this.$hamburger.on('click', this.toggleNav);
            }
        }

        class LatestNews {
            constructor() {
                this.$carousel = $(".latest-news--wrap");
                this.init();
            }

            init() {
                if (!this.$carousel.length) return;

                this.$carousel.slick({
                    fade: true,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    pauseOnHover: false
                });
            }
        }
        class Ease {
            constructor() {
                this.$easeEls = $(".ease, .list");
                this.observerEase = null;
                this.heroObserver = null;
                this.configEase = {
                    root: null,
                    rootMargin: "0px",
                    threshold: 0.3
                };

                this.hasObservedEase = this.hasObservedEase.bind(this);
                this.hasObservedHero = this.hasObservedHero.bind(this);

                this.init();
            }

            hasObservedEase(entries) {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;
                    const $target = $(entry.target);

                    if ($target.hasClass("list")) {
                        let time = 100;
                        $target.children().each((i, el) => {
                            const $el = $(el);
                            setTimeout(() => {
                                const $lastDiv = $el.find(">div:last-child");
                                const theWidth =
                                    $lastDiv.width() +
                                    parseInt($lastDiv.css("padding-left"), 10) * 2;
                                $el.addClass("show");
                                $lastDiv.css("width", theWidth);
                            }, time);
                            time += 1800;
                        });

                    } else if ($target.hasClass("num__val")) {
                        const countUp = { score: 0 };
                        const nf = Intl.NumberFormat();
                        TweenLite.to(countUp, 3, {
                            score: $target.data("num"),
                            onUpdate: () => {
                                $target.html(nf.format(countUp.score.toFixed(0)));
                            },
                            ease: "linear"
                        });

                    } else {
                        $target.addClass("show");
                    }

                    this.observerEase.unobserve(entry.target);
                });
            }

            hasObservedHero(entries) {
                entries.forEach(entry => {
                    const $header = $("#header");
                    if (entry.isIntersecting) {
                        $header.removeClass("bg");
                    } else {
                        $header.addClass("bg");
                    }
                });
            }

            init() {
                if ("IntersectionObserver" in window) {
                    this.observerEase = new IntersectionObserver(
                        this.hasObservedEase,
                        this.configEase
                    );
                    this.$easeEls.each((i, el) => this.observerEase.observe(el));

                } else {
                    // Fallback for older browsers
                    const offset = $(window).height() * 0.1;
                    $(window).on("scroll", () => {
                        const sb = $(window).scrollTop() + $(window).height();
                        this.$easeEls.each((i, el) => {
                            const $el = $(el);
                            if ($el.offset().top < sb - offset && !$el.hasClass("show")) {
                                $el.addClass("show");
                            }
                        });
                    });
                }
            }
        }

        class General {
            static _resizeTimeout = null;

            static handleResize() {
                clearTimeout(General._resizeTimeout);
                $('nav#main').removeClass('animate');
                General._resizeTimeout = setTimeout(() => {
                    $('nav#main').addClass('animate');
                }, 100);
            }

            static fixResponsiveNav() {
                $(window).on('resize', General.handleResize);
            }

            static stopScroll() {
                $('body').css({
                    position: 'static',
                    overflow: 'auto'
                });
            }

            static startScroll() {
                $('body').css({
                    position: 'sticky',
                    overflow: 'hidden'
                });
            }

            static init() {
                General.fixResponsiveNav();
                $(".hero--legacy-overlay a.btn, .shares .btn").on("click", function(e) {
                    e.preventDefault();
                    $("#team-popup.alt").addClass('active');
                    General.startScroll();
                });
                $(".announcements--header").on("click", function() {
                    $(this).toggleClass('closed');
                    $(this).next().slideToggle("slow");
                });
            }
        }

        class Carousel {
            constructor() {
                this.$carousel = $(".course__carousel");
                this.init();
            }

            init() {
                if (!this.$carousel.length) return;

                this.$carousel.each(function() {
                    const $parent = $(this);
                    $parent.find(".course__carousel-inner").slick({
                        autoplay: false,
                        infinite: true,
                        slidesToShow: 3,
                        prevArrow: $parent.find(".course__carousel-prev"),
                        nextArrow: $parent.find(".course__carousel-next"),
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });
                });
            }
        }

        class HeroShutter {
            constructor() {
                this.$hero = $('.hero-shutter');
                if (!this.$hero.length) return;

                this.$images = this.$hero.find('.hero-shutter__images');
                this.$slides = this.$hero.find('.hero-shutter__slide');
                this.$overlayA = this.$images.find('.hero-shutter__overlay--a');
                this.$overlayB = this.$images.find('.hero-shutter__overlay--b');
                this.current = 0;
                this.total = this.$slides.length;
                this.cycleDelay = 1300;   // time image is visible
                this.shutterSpeed = 450;  // matches CSS transition duration

                this.init();
            }

            openShutter() {
                this.$images.addClass('is-revealed');
            }

            closeShutter() {
                this.$images.removeClass('is-revealed');
            }

            sizeOverlaysToSlide(slideIndex) {
                const $slide = this.$slides.eq(slideIndex);
                const slideHeight = $slide.outerHeight();
                const containerHeight = this.$images.outerHeight();

                if (!containerHeight || slideHeight >= containerHeight) {
                    // Image fills container — use default CSS (51%)
                    this.$overlayA.css({ height: '', top: '', bottom: '' });
                    this.$overlayB.css({ height: '', top: '', bottom: '' });
                    return;
                }

                // Image is shorter than container — centre offset
                const offset = (containerHeight - slideHeight) / 2;
                const halfImage = Math.ceil(slideHeight / 2) + 1; // +1px overlap

                // Overlay A: top half of the image
                this.$overlayA.css({
                    top: (offset - 1) + 'px',
                    height: halfImage + 'px'
                });

                // Overlay B: bottom half of the image
                this.$overlayB.css({
                    bottom: (offset - 1) + 'px',
                    height: halfImage + 'px'
                });
            }

            nextSlide() {
                const next = (this.current + 1) % this.total;

                // Close shutter at the CURRENT image's size
                this.closeShutter();

                // After shutter closes, swap image, resize overlays, then re-open
                setTimeout(() => {
                    this.$slides.removeClass('is-active');
                    this.current = next;
                    this.$slides.eq(this.current).addClass('is-active');

                    // Resize overlays to the new image (while shutters are closed)
                    this.sizeOverlaysToSlide(this.current);

                    this.openShutter();
                }, this.shutterSpeed);
            }

            startCycle() {
                this.nextSlide();
                this.timer = setInterval(() => {
                    this.nextSlide();
                }, this.shutterSpeed + this.cycleDelay);
            }

            initHeaderObserver() {
                const $header = $('#header');

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // Hero is in view — hide logo only
                            $header.addClass('logo-hidden');
                        } else {
                            // Hero scrolled past — show logo
                            $header.removeClass('logo-hidden');
                        }
                    });
                }, {
                    threshold: 0
                });

                observer.observe(this.$hero[0]);
            }

            init() {
                // Wait for the first slide's image to finish decoding before kicking
                // off the reveal — otherwise the clip-path opens onto an empty IMG
                // box, which Safari paints as a faint rectangle outline.
                this.whenFirstImageReady(() => {
                    // Size overlays to the first (now-loaded) slide
                    this.sizeOverlaysToSlide(0);

                    // Reveal first image behind clip-path immediately (overlays open)
                    this.$images.addClass('is-revealed');

                    // Intro: split names to reveal clip-path
                    setTimeout(() => {
                        this.$hero.addClass('is-open');

                        // Start cycling after first image display time
                        if (this.total > 1) {
                            setTimeout(() => {
                                this.startCycle();
                            }, this.shutterSpeed + this.cycleDelay);
                        }
                    }, 1100); // initial delay on page load
                });

                // Hide/show header based on hero visibility
                this.initHeaderObserver();
            }

            /**
             * Resolve once the first visible hero image is fully decoded.
             * Falls back to a 2s safety timeout in case decode() rejects or stalls.
             */
            whenFirstImageReady(callback) {
                const isMobile = window.matchMedia('(max-width: 767px)').matches;
                const selector = isMobile ? '.hero-shutter__img--mobile' : '.hero-shutter__img--desktop';
                const img = this.$slides.eq(0).find(selector).get(0);

                if (!img) { callback(); return; }

                let done = false;
                const fire = () => { if (!done) { done = true; callback(); } };

                // Already cached and decoded
                if (img.complete && img.naturalWidth > 0) {
                    fire();
                    return;
                }

                // Prefer decode() so we wait until pixels are ready, not just headers
                if (img.decode) {
                    img.decode().then(fire).catch(fire);
                } else {
                    img.addEventListener('load', fire, { once: true });
                    img.addEventListener('error', fire, { once: true });
                }

                // Safety net — never block the reveal forever
                setTimeout(fire, 2000);
            }
        }

        class WorkDropdown {
            constructor() {
                this.$header = $('#header');
                this.$trigger = $('.header__work-trigger');
                this.$dropdown = $('#work-dropdown');
                this.$links = this.$dropdown.find('.work-dropdown__link');
                this.$img = this.$dropdown.find('.work-dropdown__img');
                this.$imageWrap = this.$dropdown.find('.work-dropdown__image-wrap');

                this.isOpen = false;
                this.carouselTimer = null;
                this.shutterTimer = null;
                this.carouselSpeed = 350;
                this.shutterSpeed = 350;
                this.defaultGallery = this.$dropdown.data('default-gallery') || [];
                this.currentGallery = null;
                this.preloadedImages = [];

                if (!this.$trigger.length) return;

                this.init();
            }

            preloadImages() {
                // Preload default gallery
                this.defaultGallery.forEach(src => {
                    const img = new Image();
                    img.src = src;
                    this.preloadedImages.push(img);
                });

                // Preload all link galleries
                this.$links.each((i, el) => {
                    const gallery = $(el).data('gallery');
                    if (gallery && Array.isArray(gallery)) {
                        gallery.forEach(src => {
                            const img = new Image();
                            img.src = src;
                            this.preloadedImages.push(img);
                        });
                    }
                });
            }

            toggle = (e) => {
                e.preventDefault();
                if (this.isOpen) {
                    this.close();
                } else {
                    this.open();
                }
            };

            open() {
                this.isOpen = true;
                this.$header.addClass('is-dropdown-open');
                this.$dropdown.addClass('is-open');

                // Show default image immediately (no shutter effect on first image)
                if (this.defaultGallery.length) {
                    this.currentGallery = this.defaultGallery;
                    this.$img.attr('src', this.defaultGallery[0]).addClass('is-visible');
                    this.$imageWrap.addClass('is-revealed is-no-transition');

                    // Remove no-transition flag after a frame so future transitions work
                    requestAnimationFrame(() => {
                        this.$imageWrap.removeClass('is-no-transition');
                    });

                    // If multiple default images, start carousel
                    if (this.defaultGallery.length > 1) {
                        this.startCarousel(this.defaultGallery);
                    }
                }
            }

            close() {
                this.isOpen = false;
                this.stopCarousel();

                this.$imageWrap.removeClass('is-revealed');
                this.$header.removeClass('is-dropdown-open');
                this.$dropdown.removeClass('is-open');
                this.$img.removeClass('is-visible').attr('src', '');
            }

            onLinkHover = (e) => {
                const $link = $(e.currentTarget);
                const gallery = $link.data('gallery');

                // Skip shutter if same gallery is already showing
                if (gallery === this.currentGallery) return;

                this.stopCarousel();
                this.currentGallery = gallery;

                // Close shutter
                this.$imageWrap.removeClass('is-revealed');

                // After shutter closes, swap content and re-open
                this.shutterTimer = setTimeout(() => {
                    this.shutterTimer = null;
                    if (gallery && Array.isArray(gallery) && gallery.length > 0) {
                        this.$img.attr('src', gallery[0]).addClass('is-visible');

                        if (gallery.length > 1) {
                            this.startCarousel(gallery);
                        }
                    }

                    // Re-open shutter to reveal
                    this.$imageWrap.addClass('is-revealed');
                }, this.shutterSpeed);
            };

            startCarousel(images) {
                let index = 0;
                this.carouselTimer = setInterval(() => {
                    index = (index + 1) % images.length;
                    this.$img.attr('src', images[index]);
                }, this.carouselSpeed);
            }

            stopCarousel() {
                if (this.shutterTimer) {
                    clearTimeout(this.shutterTimer);
                    this.shutterTimer = null;
                }
                if (this.carouselTimer) {
                    clearInterval(this.carouselTimer);
                    this.carouselTimer = null;
                }
            }

            onClickOutside = (e) => {
                if (this.isOpen && !$(e.target).closest('#header').length) {
                    this.close();
                }
            };

            init() {
                this.preloadImages();

                this.$trigger.on('click', this.toggle);

                this.$links.on('mouseenter', this.onLinkHover);

                $(document).on('click', this.onClickOutside);

                $(document).on('keydown', (e) => {
                    if (e.key === 'Escape' && this.isOpen) {
                        this.close();
                    }
                });
            }
        }

        class ImageHoverCarousel {
            constructor() {
                this.$wraps = $('.image-hover-wrap');
                if (!this.$wraps.length) return;
                this.carouselSpeed = 350;
                this.shutterSpeed = 350; // matches CSS transition
                this.isTouch = window.matchMedia('(hover: none)').matches;
                this.activeTouch = null; // track which touch carousel is playing
                this.init();
            }

            init() {
                this.$wraps.each((i, el) => {
                    const $wrap = $(el);
                    const $carousel = $wrap.find('.image-hover-carousel');
                    if (!$carousel.length) return;

                    const $mainImg = $wrap.find('> img');
                    const originalSrc = $mainImg.attr('src');
                    const images = [];
                    $carousel.find('img').each((j, img) => {
                        images.push($(img).attr('src'));
                    });
                    if (!images.length) return;

                    let timer = null;
                    let index = 0;
                    let isActive = false;

                    if (this.isTouch) {
                        // Touch: no shutter, just a simple carousel, one at a time
                        const instance = { el, stop: null };

                        const startTouch = () => {
                            // Stop any other active touch carousel
                            if (this.activeTouch && this.activeTouch !== instance && this.activeTouch.stop) {
                                this.activeTouch.stop();
                            }
                            this.activeTouch = instance;
                            isActive = true;
                            index = 0;
                            $mainImg.attr('src', images[0]);
                            timer = setInterval(() => {
                                index = (index + 1) % images.length;
                                $mainImg.attr('src', images[index]);
                            }, this.carouselSpeed);
                        };

                        const stopTouch = () => {
                            isActive = false;
                            if (timer) {
                                clearInterval(timer);
                                timer = null;
                            }
                            $mainImg.attr('src', originalSrc);
                            if (this.activeTouch === instance) {
                                this.activeTouch = null;
                            }
                        };

                        instance.stop = stopTouch;

                        const observer = new IntersectionObserver((entries) => {
                            entries.forEach(entry => {
                                if (entry.isIntersecting) {
                                    startTouch();
                                } else if (isActive) {
                                    stopTouch();
                                }
                            });
                        }, { threshold: 0.5 });

                        observer.observe(el);
                    } else {
                        // Desktop: shutter + carousel on hover
                        $wrap.append('<div class="image-hover-shutter image-hover-shutter--a"></div>');
                        $wrap.append('<div class="image-hover-shutter image-hover-shutter--b"></div>');

                        const startCarousel = () => {
                            isActive = true;
                            $wrap.removeClass('is-revealed');

                            setTimeout(() => {
                                if (!isActive) return;
                                index = 0;
                                $mainImg.attr('src', images[0]);
                                $wrap.addClass('is-revealed');

                                setTimeout(() => {
                                    if (!isActive) return;
                                    timer = setInterval(() => {
                                        index = (index + 1) % images.length;
                                        $mainImg.attr('src', images[index]);
                                    }, this.carouselSpeed);
                                }, this.shutterSpeed * 0.2);
                            }, this.shutterSpeed);
                        };

                        const stopCarousel = () => {
                            isActive = false;
                            if (timer) {
                                clearInterval(timer);
                                timer = null;
                            }
                            $wrap.removeClass('is-revealed');

                            setTimeout(() => {
                                if (isActive) return;
                                $mainImg.attr('src', originalSrc);
                                $wrap.addClass('is-revealed');
                            }, this.shutterSpeed);
                        };

                        $wrap.on('mouseenter', startCarousel);
                        $wrap.on('mouseleave', stopCarousel);

                        // Start in revealed state (shutters open)
                        $wrap.addClass('is-revealed');
                    }
                });
            }
        }

        class AboutVideoCarousel {
            constructor() {
                this.$wrap = $('.about-section__video-wrap');
                if (!this.$wrap.length) return;

                this.$videos = this.$wrap.find('.about-section__video');
                if (!this.$videos.length) return;

                this.current = 0;
                this.total = this.$videos.length;
                this.shutterSpeed = 350;
                this.transitioning = false;

                this.init();
            }

            preloadVideo(index) {
                return new Promise((resolve) => {
                    const video = this.$videos.eq(index).find('video')[0];
                    if (!video) { resolve(); return; }

                    if (video.readyState >= 3) {
                        resolve();
                        return;
                    }

                    video.preload = 'auto';
                    video.load();

                    const onReady = () => {
                        video.removeEventListener('canplaythrough', onReady);
                        resolve();
                    };
                    video.addEventListener('canplaythrough', onReady);
                });
            }

            watchForEnd(video) {
                if (!video) return;

                const buffer = this.shutterSpeed / 1000;
                let preloadStarted = false;
                const next = (this.current + 1) % this.total;

                const onTimeUpdate = () => {
                    if (this.transitioning) return;
                    if (!video.duration) return;

                    // Start preloading next video 3s before end
                    if (!preloadStarted && video.currentTime >= video.duration - 3) {
                        preloadStarted = true;
                        this.preloadVideo(next);
                    }

                    // Trigger shutter close at exactly shutterSpeed before end
                    if (video.currentTime >= video.duration - buffer) {
                        video.removeEventListener('timeupdate', onTimeUpdate);
                        this.nextSlide();
                    }
                };
                video.addEventListener('timeupdate', onTimeUpdate);
            }

            init() {
                // Inject shutter overlays
                this.$wrap.append('<div class="image-hover-shutter image-hover-shutter--a"></div>');
                this.$wrap.append('<div class="image-hover-shutter image-hover-shutter--b"></div>');

                // Load and play first video, then open shutters
                this.preloadVideo(0).then(() => {
                    const video = this.$videos.eq(0).find('video')[0];
                    if (video) {
                        video.currentTime = 0;
                        video.play();
                    }
                    this.$wrap.addClass('is-revealed');

                    if (this.total > 1 && video) {
                        this.watchForEnd(video);
                    }
                });
            }

            nextSlide() {
                this.transitioning = true;
                const next = (this.current + 1) % this.total;

                // Close shutters immediately — video keeps playing underneath
                this.$wrap.removeClass('is-revealed');

                // Preload next video in parallel with shutter closing
                const preloadReady = this.preloadVideo(next);
                const shutterClosed = new Promise(r => setTimeout(r, this.shutterSpeed));

                // Wait for both shutter to close AND next video to be ready
                Promise.all([preloadReady, shutterClosed]).then(() => {
                    // Swap video
                    this.$videos.removeClass('is-active');
                    this.current = next;
                    this.$videos.eq(this.current).addClass('is-active');

                    // Play next video and open shutters
                    const nextVideo = this.$videos.eq(this.current).find('video')[0];
                    if (nextVideo) {
                        nextVideo.currentTime = 0;
                        nextVideo.play();
                        this.watchForEnd(nextVideo);
                    }
                    this.$wrap.addClass('is-revealed');
                    this.transitioning = false;
                });
            }
        }

        // ── WooCommerce: Product Gallery (Slick fade carousel) ──
        class ProductGallery {
            constructor() {
                this.$carousel = $('.wc-gallery-carousel');
                if (!this.$carousel.length) return;
                this.init();
            }

            init() {
                this.$carousel.slick({
                    fade: true,
                    arrows: true,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    infinite: true,
                    speed: 500,
                    cssEase: 'ease-in-out',
                });

                // Position arrows inside the actual image (not the carousel
                // container) so they sit just inside the photo edges for both
                // landscape and portrait orientations.
                const positionArrows = () => this.positionArrows();
                this.$carousel.on('afterChange init', positionArrows);
                $(window).on('resize', positionArrows);

                // Re-run after each image loads (dimensions may not be known yet)
                this.$carousel.find('img').each(function () {
                    if (this.complete) return;
                    this.addEventListener('load', positionArrows, { once: true });
                });

                positionArrows();
            }

            positionArrows() {
                const $activeImg = this.$carousel.find('.slick-active img').first();
                if (!$activeImg.length) return;

                const carouselRect = this.$carousel[0].getBoundingClientRect();
                const imgRect = $activeImg[0].getBoundingClientRect();
                const inset = 20; // distance from the image edge

                const leftOffset = Math.max(0, imgRect.left - carouselRect.left) + inset;
                const rightOffset = Math.max(0, carouselRect.right - imgRect.right) + inset;

                this.$carousel.find('.slick-prev').css('left', leftOffset + 'px');
                this.$carousel.find('.slick-next').css('right', rightOffset + 'px');
            }
        }

        // ── WooCommerce: Lightbox ──
        class ProductLightbox {
            constructor() {
                this.$triggers = $('.wc-lightbox-trigger');
                if (!this.$triggers.length) return;

                this.$lightbox = $('<div class="wc-lightbox"><span class="wc-lightbox__close"></span><img class="wc-lightbox__img" src="" alt="" /></div>');
                $('body').append(this.$lightbox);

                this.$img   = this.$lightbox.find('.wc-lightbox__img');
                this.$close = this.$lightbox.find('.wc-lightbox__close');

                this.init();
            }

            open(src) {
                this.$img.attr('src', src);
                this.$lightbox.addClass('is-active');
                $('html').addClass('no-scroll');
            }

            close() {
                this.$lightbox.removeClass('is-active');
                $('html').removeClass('no-scroll');
                this.$img.attr('src', '');
            }

            init() {
                // Delegate so Slick-cloned slides also trigger the lightbox
                $(document).on('click', '.wc-lightbox-trigger', (e) => {
                    e.preventDefault();
                    const src = $(e.currentTarget).data('full') || $(e.currentTarget).attr('href');
                    if (src) this.open(src);
                });

                this.$close.on('click', () => this.close());

                this.$lightbox.on('click', (e) => {
                    if ($(e.target).hasClass('wc-lightbox')) {
                        this.close();
                    }
                });

                $(document).on('keydown', (e) => {
                    if (e.key === 'Escape' && this.$lightbox.hasClass('is-active')) {
                        this.close();
                    }
                });
            }
        }

        // ── WooCommerce: Product Variations (radio + dropdown sync) ──
        class ProductVariations {
            constructor() {
                this.$form = $('form.variations_form');
                if (!this.$form.length) return;

                this.variations = this.$form.data('product_variations') || [];
                this.$typeRadios = this.$form.find('input[name="attribute_pa_print-type"]');
                this.$sizeSelect = this.$form.find('.js-size-select');
                // Size taxonomy slug varies per product (pa_size, pa_size-landscape, etc.)
                this.sizeKey = this.$sizeSelect.attr('name') || '';
                this.$variationId = this.$form.find('.variation_id');
                this.$addBtn = this.$form.find('.single_add_to_cart_button');
                this.$oversizedMsg = this.$form.find('.js-oversized-message');
                this.oversizedClass = this.$oversizedMsg.data('oversized-class') || 'oversized';
                this.$frameColourWrap = this.$form.find('.js-frame-colour');
                this.$frameColourSelect = this.$form.find('.js-frame-colour-select');

                this.init();
            }

            /**
             * Show frame colour dropdown only when Framed Print is selected.
             */
            updateFrameColourVisibility() {
                if (!this.$frameColourWrap.length) return;
                const selectedType = this.$form.find('input[name="attribute_pa_print-type"]:checked').val() || '';
                const isFramed = selectedType.indexOf('framed') !== -1;
                if (isFramed) {
                    this.$frameColourWrap.show();
                } else {
                    this.$frameColourWrap.hide();
                    this.$frameColourSelect.val('');
                }
            }

            /**
             * Find matching variation from JSON based on selected attributes.
             */
            findVariation() {
                const selectedType = this.$form.find('input[name="attribute_pa_print-type"]:checked').val();
                const selectedSize = this.$sizeSelect.val();

                if (!selectedType || !selectedSize) {
                    this.$variationId.val(0);
                    this.$addBtn.addClass('disabled').prop('disabled', true);
                    return;
                }

                const match = this.variations.find((v) => {
                    const vType = v.attributes['attribute_pa_print-type'];
                    const vSize = v.attributes[this.sizeKey];
                    return (vType === selectedType || vType === '') &&
                           (vSize === selectedSize || vSize === '');
                });

                if (match) {
                    this.$variationId.val(match.variation_id);

                    // Oversized variations can't be auto-shipped — show contact message
                    // and block add-to-cart instead of enabling the button.
                    if (match.shipping_class === this.oversizedClass) {
                        this.$oversizedMsg.show();
                        this.$addBtn.addClass('disabled').prop('disabled', true);
                    } else {
                        this.$oversizedMsg.hide();
                        this.$addBtn.removeClass('disabled').prop('disabled', false);
                    }
                } else {
                    this.$variationId.val(0);
                    this.$oversizedMsg.hide();
                    this.$addBtn.addClass('disabled').prop('disabled', true);
                }
            }

            /**
             * Rebuild dropdown option labels with prices for the selected type.
             * Shows: "68 x 90    $790"
             */
            updateSizeOptions() {
                const selectedType = this.$form.find('input[name="attribute_pa_print-type"]:checked').val();

                // Build map: size_slug → display_price for selected type
                const priceMap = {};
                this.variations.forEach((v) => {
                    const vType = v.attributes['attribute_pa_print-type'];
                    const vSize = v.attributes[this.sizeKey];
                    if (vType === selectedType || vType === '') {
                        priceMap[vSize] = v.display_price;
                    }
                });

                // Update each <option> text
                this.$sizeSelect.find('option').each(function() {
                    const $opt = $(this);
                    const slug = $opt.val();

                    // Store original name on first pass
                    if (!$opt.data('name')) {
                        $opt.data('name', $opt.text().trim());
                    }

                    const name = $opt.data('name');

                    if (priceMap.hasOwnProperty(slug)) {
                        const price = parseFloat(priceMap[slug]);
                        const formatted = '$' + price.toLocaleString('en-US', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        });
                        $opt.text(name + '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0' + formatted);
                    } else {
                        $opt.text(name);
                    }
                });
            }

            /**
             * AJAX add to cart — prevents page reload, updates header cart count.
             */
            addToCart(e) {
                e.preventDefault();

                const variationId = this.$variationId.val();
                if (!variationId || variationId === '0') return;

                const btnText = this.$addBtn.text();
                this.$addBtn.text('Adding...').prop('disabled', true);

                $.post(ajax_var.ppd_ajax_url, {
                    action: 'jg_add_to_cart',
                    product_id: this.$form.find('input[name="product_id"]').val(),
                    variation_id: variationId,
                    quantity: 1,
                    print_type_value: this.$form.find('input[name="attribute_pa_print-type"]:checked').val(),
                    size_key: this.sizeKey,
                    size_value: this.$sizeSelect.val(),
                    frame_colour: this.$frameColourSelect.val() || '',
                }, (res) => {
                    if (res.success) {
                        $('.header__cart-count').text(res.data.cart_count);
                    }

                    this.$addBtn.text('Added!');
                    setTimeout(() => {
                        this.$addBtn.text(btnText).prop('disabled', false);
                    }, 1500);
                }).fail(() => {
                    this.$addBtn.text(btnText).prop('disabled', false);
                });
            }

            init() {
                // Type radio changed — update dropdown prices + find variation
                this.$typeRadios.on('change', () => {
                    this.updateSizeOptions();
                    this.findVariation();
                    this.updateFrameColourVisibility();
                });

                // Size changed — find variation
                this.$sizeSelect.on('change', () => {
                    this.findVariation();
                });

                // AJAX add to cart
                this.$form.on('submit', (e) => this.addToCart(e));

                // Initial: populate prices + find variation
                this.updateSizeOptions();
                this.findVariation();
                this.updateFrameColourVisibility();
            }
        }

        // ── Accordion (product page) ──
        class Accordion {
            constructor() {
                this.$accordions = $('.js-accordion');
                if (!this.$accordions.length) return;
                this.init();
            }

            init() {
                this.$accordions.on('click', '.js-accordion-trigger', function () {
                    const $trigger = $(this);
                    const $panel   = $trigger.next('.wc-single-product__accordion-panel');
                    const isOpen   = $trigger.attr('aria-expanded') === 'true';

                    $trigger.attr('aria-expanded', !isOpen);
                    $panel.stop(true, false).slideToggle(300);
                });
            }
        }

        // ── Image fade-in on load ──
        class ImageLoader {
            constructor() {
                this.init();
            }

            init() {
                document.querySelectorAll('img').forEach(img => {
                    if (img.complete && img.naturalWidth > 0) {
                        img.classList.add('loaded');
                    } else {
                        img.addEventListener('load', () => img.classList.add('loaded'));
                        img.addEventListener('error', () => img.classList.add('loaded'));
                    }
                });
            }
        }

        class App {
            static init() {
                new Navigation();
                new ImageLoader();
                new Ease();
                new Carousel();
                new HeroShutter();
                new WorkDropdown();
                new ImageHoverCarousel();
                new AboutVideoCarousel();
                new ProductGallery();
                new ProductLightbox();
                new ProductVariations();
                new Accordion();
                General.init();
            }
        }

        $(document).ready(() => {
            App.init();
        });
    })();
})(window.jQuery);